import { Model, belongsTo, hasMany } from 'miragejs';
import attr from 'ember-data/attr';

export default Model.extend({
  floor: belongsTo('graphql/floor'),
  amenities: hasMany('graphql/amenity'),
  assignments: hasMany('graphql/assignment'),
  assignedEmployee: belongsTo('graphql/employee'),
  utilization: belongsTo('graphql/desk-utilization'),
  mapFeature: belongsTo('graphql/map-feature'),

  name: attr('string'),
  neighborhood: attr('string'),
  deskAvailability: attr('string'), // maps to the AvailabilityEnum
  enabled: attr('boolean'),
  assignedTo: attr('string'),
  x: attr('number'),
  y: attr('number'),
});
